import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

export const MAX_ORDER_NUMBERS = 25

// Split on newlines, commas, semicolons and any whitespace — Ops paste from
// Excel/Sheets/Slack/Confluence and the separator varies.
export const parseOrderNumbers = (raw) => {
  if (!raw) return []
  const tokens = String(raw).split(/[\s,;]+/)
  const seen = new Set()
  const out = []
  for (const token of tokens) {
    const trimmed = token.trim()
    if (!trimmed) continue
    if (seen.has(trimmed)) continue
    seen.add(trimmed)
    out.push(trimmed)
  }
  return out
}

export default function OrderNumbersInput({ value, onChange, parsed, disabled }) {
  const { t } = useTranslation()
  const count = parsed.length
  const tooMany = count > MAX_ORDER_NUMBERS

  return (
    <div className="mb-2">
      <label htmlFor="nfe-order-numbers" className="block text-sm font-medium text-gray-700 mb-1">
        {t("natura_operations.nfe_status.col_order")}
      </label>
      <textarea
        id="nfe-order-numbers"
        aria-label="order_numbers"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        rows={10}
        spellCheck={false}
        autoCorrect="off"
        autoCapitalize="off"
        className="w-full font-mono text-sm border border-gray-300 rounded p-2 disabled:bg-gray-100"
        placeholder={"0254402427\n0254402428\n0254402429"}
      />
      <div className="flex items-center justify-between mt-1 text-xs">
        <span className={tooMany ? "text-red-600 font-medium" : "text-gray-500"}>
          {t("natura_operations.nfe_status.input_count", { count, max: MAX_ORDER_NUMBERS })}
        </span>
        {tooMany && (
          <span role="alert" className="text-red-600 font-medium">
            {t("natura_operations.nfe_status.input_too_many", { max: MAX_ORDER_NUMBERS })}
          </span>
        )}
      </div>
    </div>
  )
}

OrderNumbersInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  parsed: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool,
}

OrderNumbersInput.defaultProps = {
  disabled: false,
}
